module.exports = {
      id: "export-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#export-usage",
      toString: function () {
        return this.url;
      }
    }